import React, { useState } from "react";
import styles from "./index.module.scss";
import { Modal, Button } from "antd";
import { API_KEY } from "../../../config";
import { Loader, LoaderOptions } from "google-maps";

const options: LoaderOptions = {
  /* todo */
};


const loader = new Loader(API_KEY, options);

export type Props = {
  currentLocation?: any;
  findShopLocationState: (markerPosition: any) => any;
};

// var map = googlemaps;

const ShopFindLocation: React.FC<Props> = (props) => {
  const {
    currentLocation = {
      lat: 0,
      long: 0,
    },
  } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [markerPosition, setMarkerPosition] = useState({
    lat: 0,
    long: 0,
  });

  const showModal = () => {
    setIsModalVisible(true);

    setTimeout(() => {
      // console.log("init map...");
      initMap();
    }, 0);
  };

  const handleOk = () => {
    setIsModalVisible(false);

    // console.log("map =>", map);

    props.findShopLocationState(markerPosition);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const initMap = async () => {
    // console.log("init...", currentLocation);

    const google = await loader.load();

    const map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        center: { lat: currentLocation.lat, lng: currentLocation.long },
        zoom: 12,
        disableDefaultUI: true,
        zoomControl: true,
      }
    );

    const myMarker = new google.maps.Marker({
      position: map.getCenter(),
      animation: google.maps.Animation.DROP,
      draggable: true,
      map: map,
    });

    google.maps.event.addListener(myMarker, "dragend", function (evt: any) {
      setMarkerPosition({
        lat: evt.latLng.lat(),
        long: evt.latLng.lng(),
      });
    });
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        ค้นหาร้านค้า
      </Button>
      <Modal
        title="ค้นหาร้านค้า"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="ค้นหาร้านค้า"
        cancelText="ยกเลิก"
      >
        <div id="map" className={styles.map}></div>
      </Modal>
    </>
  );
};
export default ShopFindLocation;
